import * as React from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import { editorOptionsSelector } from '../../../reducers/EditorReducer/EditorSelector';
import { expressionOperatorsSelector } from '../../../reducers/ExpressionLanguageReducer/ExpressionLanguageSelector';
import { fastExpressionOperatorsSelector } from '../../../reducers/FastExpressionLanguageReducer/FastExpressionLanguageSelector';
import {
  languageComboIdsSelector,
  languageFieldIdsSelector,
  languageSelectionIdsSelector,
} from '../../../reducers/LanguageFieldsReducer/LanguageFieldsSelector';
import { editorWillMountMonaco } from '../../../shared/helpers/monaco-helper';
import { AlphaCode } from '../../AlphaCode';

import './Block.scss';

interface BlockAlphaProps {
  alpha: Immutable.Map<string, any>;
  // This function will handle the clone alpha when the user is on the simulate page
  handleSimulateClone?: (alpha: string) => void;
  learnBlockId?: string;
  isMultiTab?: boolean;
}

const BlockAlpha = (props: BlockAlphaProps) => {
  const { alpha, isMultiTab, learnBlockId } = props;
  const expressionOperators = useSelector(expressionOperatorsSelector);
  const fastExpressionOperators = useSelector(fastExpressionOperatorsSelector);
  const settingsOptions = useSelector(editorOptionsSelector);
  const languageFieldsRegularIds = useSelector(languageFieldIdsSelector);
  const languageFieldsSelectionIds = useSelector(languageSelectionIdsSelector);
  const languageFieldsComboIds = useSelector(languageComboIdsSelector);

  return (
    <AlphaCode
      alpha={alpha}
      codeElem="code-sample-content"
      editorWillMount={editorWillMountMonaco({
        expressionOperators,
        fastExpressionOperators,
        languageFieldsRegularIds,
        languageFieldsSelectionIds,
        languageFieldsComboIds,
      })}
      settingsOptions={settingsOptions}
      id={'alpha-code-container'}
      hasTitle={false}
      maxHeight={true}
      showClone={true}
      isMultiTab={isMultiTab}
      learnBlockId={learnBlockId}
    />
  );
};

export default BlockAlpha;
